import Service from "./service";

class TyreBrandLoader {
  constructor() {
    if (TyreBrandLoader._instance) {
      return TyreBrandLoader._instance;
    }

    TyreBrandLoader._instance = this;

    this.isLoading = false;
    this.options = null;
    this.lastDealerLocationId = null;
    this.promise = null;
  }

  getDropdownOptions(dealerLocationId, isTyreTeamEnabled) {
    return new Promise((resolve, reject) => {
      this.promise = { resolve, reject };
      this.load(dealerLocationId, isTyreTeamEnabled);
    });
  }

  load(dealerLocationId, isTyreTeamEnabled) {
    if (this.options && this.lastDealerLocationId === dealerLocationId) return this.resolvePromises();

    if (!this.isLoading) {
      this.isLoading = true;
      const serviceCall = isTyreTeamEnabled ? Service.getTyreTeamBrands({ dealer_location_id: dealerLocationId ?? null }) : Service.getTiresBrands();

      serviceCall
        .then(result => {
          const brands = result?.data?.data?.brands ?? [];
          if (!brands) throw new Error("invalid response when loading brands dropdown options");

          this.options = brands;
          this.lastDealerLocationId = dealerLocationId;
          this.resolvePromises();
          this.isLoading = false;
        })
        .catch(err => {
          if (err?.response?.data?.errors?.length) this.rejectPromises(err.response.data.errors[0]);
          else this.rejectPromises(err.message);

          this.isLoading = false;
        });
    }
  }

  rejectPromises(err) {
    this.promise.reject(err);
  }

  resolvePromises() {
    this.promise.resolve(this.options);
  }
}

const Brands = new TyreBrandLoader();

export default Brands;
